import { ADDON_TYPE } from '@shootsta/common-domain-data';
import { getCostForAddon, getCustomCostForAddon } from '../utils';

const icon = 'square';

export default function () {
  return ({
    billingEntityCode,
    addonsCosts,
    includedAddons,
    customAddonCosts





  }) => {
    const additionalOutputCost = getCostForAddon({
      costs: includedAddons.includes('ADDITIONAL_OUTPUT') ?
      null :
      addonsCosts.ADDITIONAL_OUTPUT.costs,
      billingEntityCode
    });

    return [
    {
      reviewLabel: 'Social Iteration',
      label: 'Additional Output',
      value: 'ADDITIONAL_OUTPUT',
      icon,
      cost: customAddonCosts && customAddonCosts.length ?
      getCustomCostForAddon({
        addonType: ADDON_TYPE.ADDITIONAL_OUTPUT,
        customAddonCosts,
        billingEntityCode
      }) :
      additionalOutputCost
    }];

  };
}